<template>
  <div v-resize="handleResize">
    <div :style="pageStyle">
      <div class="height-view">
        <slot />
      </div>
    </div>
    <div ref="bottom"></div>
  </div>
</template>

<style lang="less" scoped>
.height-view {
  overflow: var(--menu-overflow);
  height: var(--menu-height);
}
.height-view::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>

<script>
export default {
  props: {
    offsetSize: {
      type: Number,
      default: 180
    },
    overflowOffsetTop: {
      type: Number,
      default: 0
    },
    overflowOffset: {
      type: Number,
      default: 0
    },
    fixOverflow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageStyle() {
      return {
        "min-height": "100px",
        "--menu-height": `${this.boxHeight}px`,
        "--menu-overflow": `${!this.fixOverflow
          || this.isPageBottom ? 'auto' : "hidden"}`
      }
    }
  },
  data() {
    return {
      isPageBottom: false,
      boxHeight: 100,
    };
  },
  methods: {
    handleResize() {
      let height =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.boxHeight = height - this.offsetSize;
      try {
        let bottomPosition = this.$tape.getElementPosition(this.$refs.bottom);
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const clientHeight = document.documentElement.clientHeight;
        const scrollHeight = bottomPosition.top + this.overflowOffset;
        this.isPageBottom = scrollTop > this.overflowOffsetTop && scrollTop + clientHeight >= scrollHeight;
      } catch (error) {
      }
    },
  },
  mounted() {
    this.handleResize();
  },
};
</script>